import { Build } from '@todesktop/shared';
import { doc, onSnapshot } from 'firebase/firestore';
import firestore from '../../../utilities/firestore';
import { readDocumentSnapshot } from '../../../utilities/firestoreData';
import { makeProgress, CliTestProgress } from './build';

export default async function waitUntilFinished({
  appId,
  buildId,
  onProgress,
  userId,
}: {
  appId: string;
  buildId: string;
  onProgress: (progress: CliTestProgress) => void;
  userId: string;
}) {
  const docPath = `users/${userId}/applications/${appId}/builds/${buildId}`;

  return new Promise<CliTestProgress>((resolve, reject) => {
    const unsubscribe = onSnapshot(
      doc(firestore, docPath),
      (snapshot) => {
        const data = readDocumentSnapshot<Build>(snapshot);
        if (!data) {
          return;
        }
        const progress = makeProgress(data);

        onProgress(progress);

        if (progress.isFinished) {
          unsubscribe();
          resolve(progress);
        }
      },
      (err) => {
        unsubscribe();
        reject(err);
      },
    );
  });
}
